// Build information, automatically generated by `ng-info`
const build = {
    version: "25.3.0-SNAPSHOT",
    timestamp: "Thu Nov 05 2026 11:53:51 GMT+0100 (Central European Standard Time)",
    message: null,
    git: {
        user: null,
        branch: "HEAD",
        hash: "ec4fa1",
        fullHash: "ec4fa19589ddf29299e359beead0f72f255c763d"
    }
};

export default build;